<script>
    import { onMount } from "svelte";

    import { loggedInDoctorDetail } from "../../stores";

    import { apiMethods } from "../../Services/index.svelte";

    import { showError } from "../../Utils/utilFunctions.svelte";

    import AccountReports from "../Account/components/AccountReports.svelte";
    import AccountInvoiceDetails from "../Account/components/AccountInvoiceDetails.svelte";

    let isLoadingInvoices = false,
        invoicesDetails = [];

    onMount(() => {
        loadInvoices();
    });

    const loadInvoices = async () => {
        isLoadingInvoices = true;

        await apiMethods.getMethod
            .getAccountInvoice(0, 999999, { "filter[doctorId]": $loggedInDoctorDetail.id })
            .then((res) => {
                if (!res || res.error) {
                    showError(
                        res.error ??
                            "Failed to load invoices, please refresh the page and try again and contact support if the issue persists.",
                    );
                    invoicesDetails = [];
                } else invoicesDetails = [...res.results];
            });

        isLoadingInvoices = false;
    };
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 m-4">
        <AccountReports accountId={$loggedInDoctorDetail.id} />

        <AccountInvoiceDetails {invoicesDetails} />
    </div>
</div>
